import React from 'react'
import ReactDOM from 'react-dom'
import * as d3 from "../d3.modified.js"
import Indicators from './Indicators'
import {InlineTex} from 'react-tex'

export default class IconNode extends React.PureComponent {
    constructor(props) {
        super(props)
        // this.isJustClickNotDrag = false
        this.props.nodeItem.refs = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove,
            styleFade: this.styleFade,
            styleLinked: this.styleLinked,
            destyleLinked: this.destyleLinked,
            dom: this,
        }
        // this.props.nodeItem.height = 70
    }

    styleLinked = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'linkedto',
            val: true,
        })
    }

    destyleLinked = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'linkedto',
            val: false,
        })
    }

    componentDidMount() {
        this.postModifiers()

        var node = this.props.nodeItem

        const _step = 10

        if (node._selectionId!==-1) {
            this.styleSelect()
        }

        node.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        this.position = undefined;

        if (this.props.edit) {
            node.refs.holder.call(d3.drag()
                .on('start', ()=>{
                    this.position = {x:d3.event.x, y:d3.event.y}
                    this.props.hideCtxMenus()

                    // <grided>
                    this.startDragMPosX = d3.event.x
                    this.startDragMPosY = d3.event.y
                    this.startDragPosX = node.x
                    this.startDragPosY = node.y
                    // </grided>

                    this.props.dragStartHandler()
                })
                .on('drag', ()=>{
                    node.refs.holder.classed('moving', true)

                    if (node._selectionId === -1) {
                        this.props.clickHandler(node, true)
                    }
                    if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {
                        // <grided>
                        if (this.props.keyPressDict.shift) {
                            let x = this.startDragPosX + (d3.event.x-this.startDragMPosX)-this._width*0.5
                            let y = this.startDragPosY + (d3.event.y-this.startDragMPosY)-10//node.height*0.5
                            x = parseInt((x+_step/2)/_step)*_step
                            y = parseInt((y+_step/2)/_step)*_step

                            let dx = x-node.x+this._width*0.5
                            let dy = y-node.y//node.height*0.5
                            this.props.dragHandler(dx, dy)
                        } else {
                        // </grided>
                            this.props.dragHandler(d3.event.dx, d3.event.dy)
                        }
                    }
                })

                .on('end', ()=>{
                    node.refs.holder.classed('moving', false)
                    let newPosition = {x:d3.event.x, y:d3.event.y}
                    if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                        //this.props.dragEndHandler()
                        this.props.resizeEndHandler()
                    }
                })
            )
        }

        node.refs.holder
            .on('mouseenter', ()=>{
                this.props.highlightConnections(node)
                if (this.props.keyPressDict.link) {
                    if (this.props.canCreateLink(node)) {
                        node.refs.holder.classed('linkage-can', true)
                    } else {
                        node.refs.holder.classed('linkage-cannot', true)
                    }
                }
            })
            .on('mouseleave', ()=>{
                this.props.dehighlightConnections(node)
                if (this.props.keyPressDict.link) {
                    node.refs.holder.classed('linkage-can', false)
                    node.refs.holder.classed('linkage-cannot', false)
                }
            })

        node.refs.holder
            .on("click", ()=>{
                if (this.props.keyPressDict.link) {
                    this.props.createLink(node)
                } else {
                    this.props.clickHandler(node)
                }
                d3.event.stopPropagation()
            }).on("dblclick", ()=>{
                node.properties.url.forEach(url=>{
                    window.open((url.href.substr(0,4)==='http'?'':'//')+url.href, '_blank');
                })
                d3.event.stopPropagation()
            })
    }

    postModifiers = () => {
        var node = this.props.nodeItem

        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}

        //var bb = node.refs.title.getBBox()
        let bb = ReactDOM.findDOMNode(node.refs.title).getBoundingClientRect()
        let k = this.props.nodebookComponent.currentZoomTransform.k
        this._width = bb.width/k
        this._height = bb.height/k

        _(node.refs.background, 'width', this._width)
        _(node.refs.background, 'height', this._height)
        _(node.refs.background, 'x', -(this._width)/2)
        _(node.refs.background, 'y', -(this._height)/2)

        if (this._width) ReactDOM.findDOMNode(node.refs.titleHolder).setAttribute('x', -(this._width)/2)
        if (this._height) ReactDOM.findDOMNode(node.refs.titleHolder).setAttribute('y', -(this._height)/2)
        if (this._width) ReactDOM.findDOMNode(node.refs.titleHolder).setAttribute('width', this._width)
        if (this._height) ReactDOM.findDOMNode(node.refs.titleHolder).setAttribute('height', this._height)
        if (this._height && node.refs.indicator && node.refs.indicator.indicatorHolder) ReactDOM.findDOMNode(node.refs.indicator.indicatorHolder).setAttribute('y', this._height/2 + 10)

        // this.props.enqueueStyleChange({
        //     elem: node.refs.background,
        //     prop: 'fill',
        //     val: node.properties.color
        // })
        // this.props.enqueueStyleChange({
        //     elem: node.refs.icon,
        //     prop: 'fill',
        //     val: node.properties.color
        // })
    }

    componentDidUpdate() {
        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        var node = this.props.nodeItem
        this.props.enqueueStyleChange({
            elem: node.refs.background,
            prop: 'fill',
            val: node._compareType?diffColors[node._compareType]:node.properties.color
        })
        this.postModifiers()
    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x} ${node.y})`
        })
    }

    styleSelect = () => {
        var node = this.props.nodeItem
        // this.props.enqueueClassChange({
        //     elem: node.refs.icon,
        //     class: 'active',
        //     val: true,
        // })
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        // this.props.enqueueClassChange({
        //     elem: node.refs.icon,
        //     class: 'active',
        //     val: false,
        // })
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: false,
        })
    }

    styleFade = () => {
        this.props.nodeItem.refs.holder
            .transition()
                .duration(400)
                .style('opacity', 0)
    }

    render() {
        var node = this.props.nodeItem

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        const height = Math.floor(node.properties._render.title.fontSize.replace('px',''))*1.4

        const {display, ...rest} = node.properties._render['title']

        let fStyle = {
            fontSize: rest.fontSize,
            fontStyle: rest.fontStyle,
            fontWeight: rest.fontWeight,
            color: rest.fill,
            lineHeight: height+'px',
            textAlign: rest.textAlign,
            paddingLeft: '5px',
            paddingRight: '5px'
            // backgroundColor: rest.backgroundColor,
        }

        return (
            <g
                className="node-holder node-supercategory-holder"
                transform={`translate(${node.x} ${node.y})`}
                ref={c=>node.refs.holder=d3.select(c)}
                opacity="0"
            >
            {/* ICON */}
                {
                    (node.properties.image!=='')
                        ? (
                            <image
                                x="-25"
                                y="-25"
                                width="50"
                                height="50"
                                clipPath="url(#kruzic)"
                                className="node-supercategory-circle-img"
                                transform="translate(0 -45)"
                                href={node.properties.image}
                                id={`N_${node.id}_img`}
                            />
                        ) : null
                }
                <rect
                    className="node-supercategory-background"
                    //width={(this._width||node.width)+10}
                    //height={height}
                    rx="3"
                    ry="3"
                    ref={c=>node.refs.background=d3.select(c)}
                    //x={-(this._width||node.width)/2-5}
                    y={-height*0.5}
                    key="bg"
                    id={`N_${node.id}_bg`}
                    style={{
                        fill: node._compareType
                            ? diffColors[node._compareType]
                            : node.properties.color,
                        stroke: node._compareType
                            ? 'transparent'
                            : node.properties.bdcolor
                    }}
                    // style={{fill: node.properties.color}}
                />
                <foreignObject
                    key="title"
                    y={"-10"}
                    ref={c=>node.refs.titleHolder=c}
                    className="node-supercategory-name"
                >
                    <div
                        ref={c=>node.refs.title=c}
                        style={{...fStyle, display:'inline-block', overflow:'hidden', whiteSpace:'nowrap'} || {}}
                    >
                        <InlineTex texContent={node.properties.title===''?'(untitled)':node.properties.title}/>
                    </div>
                </foreignObject>
                {/* <text
                    key="title"
                    x="0"
                    y={height/4.}
                    className="node-supercategory-name"
                    textAnchor="middle"
                    alignmentBaseline="baseline"
                    ref={c=>node.refs.title=c}
                    style={node.properties._render['title'] || {}}
                >{node.properties.title===''?'(untitled)':node.properties.title}</text> */}
                <Indicators
                    x="0"
                    y={height/1.4 + 10}
                    _c={node.comments}
                    _l={node.properties.url.length}
                    _f={node.properties.files.length}
                    ref={c=>node.refs.indicator=c}
                />
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/SuperCategoryNode.js